const STANDARD = "standard";
const RICH = "rich";
export const CONTENT_FORMAT_TYPE = {
  STANDARD,
  RICH
};
